import { CircularProgress } from "@mui/material"

export const Loading = () => {
  return (
    <div className="w-full h-full flex items-center justify-center text-secondary"><CircularProgress thickness={2} color="var(--primary-color)" /></div>
  )
}